import { takeEvery, call, put } from 'redux-saga/effects'
import CryptoJS from 'crypto-js'
import {
  registerFormSubmitSuccess,
  registerFormSubmitUserExistError,
  registerFormSubmitFailed
} from '../../actions/employer/index'
import { REGISTER_FORM_SUBMIT } from '../../constants/employer/index'
import { KVT_IDENTITY_SERVER } from '../../constants'
import { registerPost } from '../../utils/employer/request'

/**
 * register.saga of employer side is copied from register.saga user side
 * if this is updated, let check and done the same things with user side
 */

/**
 * @author Pragya Gupta
 */

function* sendRegisterInfo({ values }) {
  try {
    const url = `${KVT_IDENTITY_SERVER}/RegisterUser`
    const refinedForm = Object.assign({}, { ...values })
    const hashedPassword = CryptoJS.SHA256(refinedForm.password).toString()

    const body = JSON.stringify({
      email: refinedForm.email,
      companyname: refinedForm.company_name,
      contactname: refinedForm.contact_name,
      businessid: refinedForm.y_tunnus,
      password: hashedPassword,
      SubjectId: refinedForm.email,
      usertype: 'employer'
    })

    const result = yield call(registerPost, url, body)

    if (result.data.Server === 'Success') {
      yield put(registerFormSubmitSuccess(result.data.Server))
    } else if (result.data.Server === 'UserExist') {
      yield put(registerFormSubmitUserExistError(result.data.Server))
    } else {
      yield put(registerFormSubmitFailed(result.data.Server))
    }
  } catch (error) {
    yield put(registerFormSubmitFailed(error))
  }
}

// function* loadSignUpFromSite() {
//   try {

//     const searchPath = store.getState().routing.locationBeforeTransitions.search
//     console.log('searchPath:: ', searchPath)

//     if(searchPath !== ''){
//       const siteFirstName = store.getState().routing.locationBeforeTransitions.query.firstname
//       console.log('siteFirstName:: ',siteFirstName)

//       const siteLastName = store.getState().routing.locationBeforeTransitions.query.lastname
//       console.log('siteLastName:: ',siteLastName)

//       const siteEmail = store.getState().routing.locationBeforeTransitions.query.email
//       console.log('siteEmail:: ',siteEmail)

//       yield put(change('register', 'FirstName', siteFirstName))

//       yield put(change('register', 'Lastname', siteLastName))

//       yield put(change('register', 'email', siteEmail))

//       let searchQuery = store.getState().routing.locationBeforeTransitions.search
//       let stringIncludes = 'trp-form-language'

//       const siteLang = langQuery(searchQuery, stringIncludes)
//       console.log('siteLang:: ', siteLang)

//       yield put(handleChangeLang(siteLang))
//     }

//   } catch (error) {
//     console.warn(error)
//   }
// }

export function* watchSendRegisterInfoSaga() {
  yield takeEvery(REGISTER_FORM_SUBMIT, sendRegisterInfo)
}

// export function* watchLoadRegisterFromSiteSaga() {
//   yield take(LOAD_SIGNUP_FROM_SITE)
//   yield fork(loadSignUpFromSite)
// }
